export default "__VITE_ASSET__a3dac425__"